<template>
    <div class="tyn-root">
        <Header></Header>

        <div class="tyn-content tyn-content-page">
            <div class="tyn-main">
                <div class="tyn-section py-4">
                    <div class="container-xxl home-container">
                        <div class="tyn-text-block text-center pb-4 pb-lg-4">
                            <div class="tyn-logo">
                                <img class="img-responsive logo-avatar" src="assets/images/sollai/avatar.png" />
                            </div>
                            <h1 class="main-title mt-3">Bem vindo à SollAI!</h1>
                            <p class="subtitle">O que deseja fazer hoje?</p>
                            <div class="home-search" v-if="!mostrarCardsDetalhados">
                                <div class="search-box">
                                    <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" />
                                    </svg>
                                    <input type="text"
                                           class="modern-search-input"
                                           placeholder="Pesquise o que você procura…"
                                           aria-label="Pesquisa"
                                           v-model="termoBusca"
                                           @keyup.enter="irParaPesquisa" />
                                    <button class="modern-btn modern-btn-primary" type="button" @click="irParaPesquisa">
                                        Buscar
                                    </button>
                                </div>
                            </div>
                            <template v-if="manual != null">
                                <ManualFerramenta :name="manual.name"
                                                  :btnClass="'btn-manual-tool'"
                                                  :nameBtn="manual.nameBtn"
                                                  :urlPdf="manual.urlPdf" />
                            </template>
                        </div><!-- .tyn-text-block -->
                        <div class="card-container card-grid-inicio" v-if="!mostrarCardsDetalhados">
                            <div class="card-grid-inicio__wrap" v-for="(item,index) in lstCards" :key="index">
                                <div :class="'card card-opcao text-center' + ( item.flPossuiProduto ? ' animacao':' m-card-block')" @click="(item.flPossuiProduto? acaoCard(index) : null)">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center">
                                        <div class="icon-wrapper">
                                            <img class="img-card" :class="(item.classe?item.classe:'')" :src="item.icone" alt="provisorio">
                                        </div>
                                        <h3 class="card-title">{{item.name}}</h3>
                                        <p class="card-description">{{item.descricao}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row g-2 g-sm-3 justify-content-center text-center row-cards-links align-items-stretch" :class="gridProcessos ? 'row-cols-1 row-cols-sm-2 row-cards-links--grid' : 'row-cols-3'" v-else>
                            <div class="d-flex min-w-0" :class="(gridProcessos ? 'col-12 col-sm-6' : 'col-12 col-sm-4')" v-for="(item,index) in lstLinks" :key="index">
                                <div :class="'card card-opcao card-opcao-link text-center h-100 border-0 w-100'+ ( item.flPossuiProduto ? ' animacao':' m-card-block')">
                                    <div class="card-body d-flex flex-column justify-content-center align-items-center flex-grow-1" @click="(item.flPossuiProduto ? navegarIcone(item.id): null)">
                                        <div class="icon-wrapper-small">
                                            <img :class="(item.descricao?'img-card':'img-icone')" :src="item.img" :alt="item.name">
                                        </div>
                                        <h4 class="title title-link-card mt-3 mb-0">{{item.nome}}</h4>
                                        <p class="card-description" v-if="item.descricao">{{item.descricao}}</p>
                                    </div>
                                </div><!-- .card -->
                            </div><!-- .col -->
                        </div><!-- .row -->
                    </div><!-- .container -->
                </div><!-- .tyn-section -->
            </div><!-- .tyn-main -->
        </div><!-- .tyn-content -->
        <div class="tyn-footer border-top">
            <div class="bg-white text-center py-3">
                <p class="mb-0 small footer-text">
                    &copy; {{ano}} <a class="footer-link" target="_blank" href="https://negociospublicos.com.br/">Grupo Negócios Públicos</a>.
                </p>
            </div>
        </div><!-- .tyn-footer -->
        <!-- MODAIS HEADER -->
        <Modais></Modais>

    </div><!-- .tyn-root -->
</template>
<script>
    import Header from '@/components/Header'
    import Modais from '@/components/Modais'
    import { navegacaoKey } from '@/config/global'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'
    import moment from 'moment'
    import ManualFerramenta from '@/components/Ferramentas/ManualFerramenta'

    export default {
        name: 'Home',
        components: { Header, Modais, ManualFerramenta },
        data: function () {
            return {
                mostrarCardsDetalhados: false,
                gridProcessos: false,
                termoBusca: '',
                ano: moment().format('YYYY'),

                componente: "Consulta",

                lstCards: [

                    {
                        name: 'SollAI Chat',
                        descricao: 'Consultas inteligentes, analisadores especializados e rascunhos de artefatos',
                        icone: '/assets/images/sollai/icone-sollaichat.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        name: 'Orientação Técnica',
                        descricao: 'IA potencializada pela inteligência humana do nosso corpo técnico especializado.',
                        icone: '/assets/images/sollai/account-supervisor-outline.png',
                        cdIdentificador: 'SO',
                        flPossuiProduto: null,
                    },
                    
                    //{
                    //    name: 'Catálogo de Itens',
                    //    descricao: 'Gerencie seus itens ligados ao CatMat/CatSer.',
                    //    icone: '/assets/images/sollai/box-seam.png',
                    //    cdIdentificador: 'PI',
                    //    flPossuiProduto: null,
                    //},
                    //{
                    //    name: 'Registro de Necessidades',
                    //    descricao: 'Registre demandas do setor para contratação.',
                    //    icone: '/assets/images/sollai/icone-sollaregistro.png',
                    //    cdIdentificador: 'PI',
                    //    flPossuiProduto: false,
                    //},
                    // Oculto até a aprovação do fluxo. Ao liberar, descomente o card,
                    // recoloque o case 2 de acaoCard (irParaRequisicaoCompra) e volte a grade para 5 + 6.
                    //{
                    //    name: 'Requisições de Compras',
                    //    descricao: 'Registre e acompanhe as requisições de compras da instituição.',
                    //    icone: '/assets/images/sollai/icone-requisicaocompra.svg',
                    //    cdIdentificador: 'PI',
                    //    flPossuiProduto: null,
                    //},
                    {
                        name: 'Processos Inteligentes',
                        descricao: 'Geração de artefatos inteligentes e gestão de processos de licitação com IA',
                        icone: '/assets/images/sollai/icone-processosinteligentes.png',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    
                    {
                        name: 'SollAI Academy',
                        descricao: 'Trilhas personalizadas com IA para acelerar seu domínio nas compras públicas.',
                        icone: '/assets/images/sollai/icone-sollacademy.png',
                        cdIdentificador: 'SA',
                        flPossuiProduto: null,
                    },
                    {
                        name: 'Lei Comentada',
                        descricao: 'As Leis 14.133/21, 13.303/06 e 8.666/93 comentadas com doutrinas, acórdãos, links de conteúdo, artigos, vídeos e comentários exclusivos.',
                        icone: '/assets/images/sollai/lei-min.png',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                    {
                        name: 'Fornecedores',
                        icone: '/assets/images/sollai/fornecedores-min.png',
                        descricao: 'Encontre produtos e serviços de fornecedores cadastrados na plataforma',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                    {
                        name: 'Editais',
                        icone: '/assets/images/sollai/editais-min.png',
                        descricao: 'Pesquise editais de licitações públicas por termo, data, estado e modalidade.',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                    {
                        name: 'Banco de Penalidades',
                        icone: '/assets/images/sollai/banco-min.png',
                        descricao: 'Consulte penalidades aplicadas a fornecedores por nome, CPF ou CNPJ.',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                    {
                        name: 'Periódicos',
                        icone: '/assets/images/sollai/periodicos-min.png',
                        descricao: 'Quatro periódicos temáticos de referência nacional, com edições mensais para profissionais que precisam estar sempre atualizados.',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                    {
                        name: 'Modelos',
                        descricao: 'Acesse modelos prontos para apoiar rotinas de contratação pública, otimizando a elaboração de documentos e peças técnicas.',
                        icone: '/assets/images/sollai/modelos-min.png',
                        cdIdentificador: '',
                        flPossuiProduto: true,
                        classe: ' invert'
                    },
                ],

                lstLinks: [
                    {
                        id: 1,
                        nome: 'Consulta Inteligente',
                        img: '/assets/images/sollai/text.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 2,
                        nome: 'Artefato',
                        img: '/assets/images/sollai/leis.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 3,
                        nome: 'Research',
                        img: '/assets/images/sollai/search.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 4,
                        nome: 'Parecer Parametrizado',
                        img: '/assets/images/sollai/parecerparametrizado.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    
                ],

                lstLinksProcesso: [
                    {
                        id: 5,
                        nome: 'Catálogo de Itens',
                        img: '/assets/images/sollai/box-seam.png',
                        descricao: 'Gerencie seus itens ligados ao CatMat/CatSer.',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        id: 6,
                        nome: 'Registro de Necessidades',
                        img: '/assets/images/sollai/icone-sollaregistro.png',
                        descricao: 'Registre demandas do setor para contratação.',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        id: 8,
                        nome: 'Analisadores de Processos',
                        img: '/assets/images/sollai/analise-icon.png',
                        descricao: 'Analise processos de licitação com analisadores especializados em IA.',
                        cdIdentificador: 'AP',
                        flPossuiProduto: null,
                    },
                    {
                        id: 7,
                        nome: 'Criação de Processos Licitatórios',
                        img: '/assets/images/sollai/icone-processosinteligentes.png',
                        descricao: 'Automatização de fluxos, assinaturas, e geração de artefatos com IA',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                ],

                manual: null,
            }
        },

        methods: {
            load() {
                if (localStorage.getItem(navegacaoKey) != null) {
                    this.navegarIcone(localStorage.getItem(navegacaoKey));
                }

                let $this = this;
                axios.get(`${urlApi}/Produto/GetPermissoesProdutos`)
                    .then(res => {
                        if (res.data.success) {
                            res.data.data.forEach(item => {
                                $this.lstCards.forEach(item2 => {
                                    if (item.produto.cdIdentificador == item2.cdIdentificador) {
                                        item2.flPossuiProduto = item.flPossuiProduto;
                                    }
                                })

                                $this.lstLinks.forEach(item2 => {
                                    if (item.produto.cdIdentificador == item2.cdIdentificador) {
                                        item2.flPossuiProduto = item.flPossuiProduto;
                                    }
                                })

                                $this.lstLinksProcesso.forEach(item2 => {
                                    if (item.produto.cdIdentificador == item2.cdIdentificador) {
                                        item2.flPossuiProduto = item.flPossuiProduto;
                                    }
                                })
                            })
                        }
                    })
                    .catch(res => {
                        if (res.response.data != undefined) {
                            avisoErro(res.response.data);
                        } else {
                            avisoErro(res.response.statusText);
                        }
                    });
            },
            resetHome() {
                this.mostrarCardsDetalhados = false;
                this.gridProcessos = false;
                this.lstLinks = [
                    {
                        id: 1,
                        nome: 'Consulta Inteligente',
                        img: '/assets/images/sollai/text.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 2,
                        nome: 'Artefato',
                        img: '/assets/images/sollai/leis.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 3,
                        nome: 'Research',
                        img: '/assets/images/sollai/search.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                    {
                        id: 4,
                        nome: 'Parecer Parametrizado',
                        img: '/assets/images/sollai/parecerparametrizado.png',
                        cdIdentificador: 'SC',
                        flPossuiProduto: null,
                    },
                ];

                this.lstLinksProcesso = [
                    {
                        id: 5,
                        nome: 'Catálogo de Itens',
                        img: '/assets/images/sollai/box-seam.png',
                        descricao: 'Gerencie seus itens ligados ao CatMat/CatSer.',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        id: 6,
                        nome: 'Registro de Necessidades',
                        img: '/assets/images/sollai/icone-sollaregistro.png',
                        descricao: 'Registre demandas do setor para contratação.',
                         cdIdentificador: 'PI',
                        flPossuiProduto: null,
                    },
                    {
                        id: 8,
                        nome: 'Analisadores de Processos',
                        img: '/assets/images/sollai/analise-icon.png',
                        descricao: 'Analise processos de licitação com analisadores especializados em IA.',
                        cdIdentificador: 'AP',
                        flPossuiProduto: null,
                    },
                    {
                        id: 7,
                        nome: 'Processos Inteligentes',
                        img: '/assets/images/sollai/icone-processosinteligentes.png',
                        descricao: 'Mais controle e eficiência na gestão dos seus processos de licitação, com IA, modelos próprios e fluxos de trabalho automatizados',
                        cdIdentificador: 'PI',
                        flPossuiProduto: null,

                    },
                ];

                this.manual = null;

                this.load();
            },
            navegarIcone(funcao) {
                switch (funcao) {
                    case 1:
                        // Consulta
                        this.$router.push({ name: 'Consulta' });
                        break;
                    case 2:
                        // Artefato
                        this.$router.push({ name: 'Artefato' });
                        break;
                    case 3:
                        // Research
                        this.$router.push({ name: 'Research' });
                        break;
                    case 4:
                        // Parecer Parametrizado
                        this.$router.push({ name: 'ParecerParametrizado' });
                        break;


                    case 5:
                        this.irParaCatalogoItens();
                        break;
                    case 6:
                        this.irParaRegistroNecessidade();
                        break;
                    case 7:
                        this.irParaProcessos();
                        break;
                    case 8:
                        this.irParaAnalisadoresProcesso();
                        break;
                }
            },

            irParaAnalisadoresProcesso() {
                this.$router.push({ path: '/AnalisadoresProcesso' });
            },

            acaoCard(tipo) {
                switch (tipo) {
                    case 0:
                        this.mostrarCardsDetalhados = true;
                        this.gridProcessos = true;
                        this.manual = {
                            name: 'Manual SollAI Chat',
                            nameBtn: 'Manual',
                            urlPdf: '/manuais/Manual SollAI Chat.pdf',
                        };
                        break;
                    case 1:
                        this.irParaOrientacoes();
                        break;
                    case 2:
                        this.mostrarCardsDetalhados = true;
                        this.gridProcessos = true;
                        this.lstLinks = this.lstLinksProcesso;
                        //this.irParaProcessos();
                        this.manual = {
                            name: 'Manual Processo Inteligente',
                            nameBtn: 'Manual',
                            urlPdf: '/manuais/Manual do processo inteligente.pdf',
                        };
                        break;
                    
                    case 3:
                        this.irParaSollAcademy();
                        break;
                    case 4:
                        this.irParaLeiComentada();
                        break;

                    case 5:
                        this.irParaFornecedores();
                        break;
                    case 6:
                        this.irParaEditais();
                        break;
                    case 7:
                        this.irParaBancoPenalidades();
                        break;
                    case 8:
                        this.irParaPeriodicos();
                        break;
                    case 9:
                        this.irParaModelos();
                        break;
                }
            },

            irParaProcessos() {
                this.$router.push({ path: '/processosinteligentes' });
            },
            irParaRequisicaoCompra() {
                this.$router.push({ name: 'RequisicaoCompra' });
            },
            irParaRegistroNecessidade() {
                this.$router.push({ path: '/RegistroNecessidade' });
            },
            irParaSollAcademy() {
                this.$router.push({ path: '/SollAcademy' });
            },
            irParaOrientacoes() {
                this.$router.push({ path: '/Orientacoes' });
            },
            irParaCatalogoItens() {
                this.$router.push({ path: '/CatalogoItens' });
            },
            irParaFornecedores() {
                this.$router.push({ name: 'Fornecedores' });
            },
            irParaEditais() {
                this.$router.push({ name: 'Editais' });
            },
            irParaBancoPenalidades() {
                this.$router.push({ name: 'BancoPenalidades' });
            },
            irParaPeriodicos() {
                this.$router.push({ name: 'Periodicos' });
            },
            irParaLeiComentada() {
                this.$router.push({ name: 'LeiComentada' });
            },
            irParaModelos() {
                this.$router.push({ name: 'Modelos' });
            },
            irParaPesquisa() {
                const termo = (this.termoBusca || '').trim()
                this.$router.push({ name: 'Pesquisa', query: termo ? { termo } : {} })
            }

        },
        mounted: function () {
            this.load();

            this.$root.$on('reset-home', this.resetHome);
        },
        beforeDestroy() {
            this.$root.$off('reset-home', this.resetHome);
        },

    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="css" scoped>
    /* Animação suave de entrada */
    @keyframes fadeInUp {
        from {
            opacity: 0;
            transform: translateY(20px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    /* Tipografia moderna e refinada */
    .main-title {
        font-weight: 700;
        font-size: 2.25rem;
        letter-spacing: -0.02em;
        color: #1a1a1a;
        margin-bottom: 0.75rem;
        animation: fadeInUp 0.6s ease-out;
    }

    .subtitle {
        font-size: 1.125rem;
        color: #64748b;
        font-weight: 400;
        letter-spacing: -0.01em;
        animation: fadeInUp 0.6s ease-out 0.1s both;
    }

    .home-search {
        max-width: 640px;
        margin: 1.25rem auto 0;
        animation: fadeInUp 0.6s ease-out 0.15s both;
    }

    .search-box {
        position: relative;
        display: flex;
        align-items: center;
        gap: 8px;
        width: 100%;
    }

    .search-icon {
        position: absolute;
        left: 16px;
        top: 50%;
        transform: translateY(-50%);
        color: #9ca3af;
        pointer-events: none;
        z-index: 1;
    }

    .modern-search-input {
        flex: 1;
        min-width: 0;
        padding: 10px 16px 10px 46px;
        border: 2px solid #e5e7eb;
        border-radius: 10px;
        font-size: 14px;
        transition: all 0.3s ease;
        background: #f9fafb;
        color: #1f2937;
    }

    .modern-search-input:focus {
        outline: none;
        border-color: #2563eb;
        background: white;
        box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
    }

    .modern-btn {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        border: none;
        cursor: pointer;
        min-height: 42px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
        white-space: nowrap;
    }

    .modern-btn-primary {
        background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
        color: white;
    }

    .modern-btn-primary:hover {
        background: linear-gradient(135deg, #1d4ed8 0%, #1e40af 100%);
    }

    .logo-avatar {
        animation: fadeInUp 0.6s ease-out 0.05s both;
        filter: drop-shadow(0 4px 12px rgba(0, 0, 0, 0.08));
    }

    /* Cards principais */
    .card-body {
        cursor: pointer;
        padding: 1rem;
    }

    .icon-wrapper {
        margin-bottom: 1.25rem;
        transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    }

    .card-opcao.animacao:hover .icon-wrapper {
        transform: scale(1.08);
    }

    .img-card {
        height: 85px;
        filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.06));
    }

    .card-title {
        font-weight: 600;
        font-size: 1.375rem;
        margin-bottom: 0.625rem;
        color: #1e293b;
        letter-spacing: -0.01em;
        line-height: 1.3;
    }

    .card-description {
        font-size: 0.89rem;
        color: #64748b;
        margin: 0;
        line-height: 1.5;
        font-weight: 400;
    }

    .box-acao {
        height: 130px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .card-container {
        animation: fadeInUp 0.6s ease-out 0.2s both;
    }

    /* 10 cards: 4 na primeira linha e 6 na segunda (Requisições de Compras oculto) */
    .home-container {
        max-width: 1520px;
    }

    .card-grid-inicio {
        --card-gap: 0.7rem;
        display: grid;
        grid-template-columns: repeat(12, minmax(0, 1fr));
        column-gap: 0;
        row-gap: var(--card-gap);
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        padding: 0;
        box-sizing: border-box;
        align-items: stretch;
    }

    .card-grid-inicio__wrap {
        display: flex;
        min-width: 0;
        padding: 0 calc(var(--card-gap) / 2);
        box-sizing: border-box;
    }

    .card-grid-inicio__wrap:nth-child(-n + 4) {
        grid-column: span 3;
    }

    .card-grid-inicio__wrap:nth-child(n + 5) {
        grid-column: span 2;
    }

    .card-grid-inicio__wrap .card-opcao {
        width: 100%;
        min-width: 0;
        max-width: none;
        height: 100%;
        min-height: 200px;
        padding: 0.7rem 0.5rem;
    }

    .card-grid-inicio .card-body {
        padding: 0.45rem 0.3rem;
    }

    .card-grid-inicio .img-card {
        height: 46px;
    }

    .card-grid-inicio .card-title {
        font-size: 0.92rem;
        margin-bottom: 0.3rem;
        line-height: 1.25;
    }

    .card-grid-inicio .card-description {
        font-size: 0.72rem;
        line-height: 1.35;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .card-grid-inicio .icon-wrapper {
        margin-bottom: 0.55rem;
    }

    .card-opcao {
        min-width: 280px;
        max-width: 360px;
        height: 260px;
        cursor: pointer;
        transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1), box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1), border-color 0.4s cubic-bezier(0.4, 0, 0.2, 1);
        border-radius: 1.25rem;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 1.5rem;
        background: #ffffff;
        border: 1px solid rgba(226, 232, 240, 0.8);
        position: relative;
        overflow: hidden;
    }

        .card-opcao::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: radial-gradient(circle at top left, rgba(59, 130, 246, 0.04), transparent 60%), radial-gradient(circle at bottom right, rgba(139, 92, 246, 0.04), transparent 60%);
            opacity: 0;
            transition: opacity 0.5s cubic-bezier(0.4, 0, 0.2, 1);
            pointer-events: none;
        }

        .card-opcao.animacao:hover::before {
            opacity: 1;
        }

        .card-opcao.animacao:hover {
            transform: translateY(-8px);
            box-shadow: 0 16px 32px rgba(59, 130, 246, 0.12), 0 8px 16px rgba(139, 92, 246, 0.08), 0 4px 8px rgba(0, 0, 0, 0.06);
            border-color: rgba(147, 197, 253, 0.5);
        }

    .m-card-block {
        opacity: 0.45;
        cursor: not-allowed;
        filter: grayscale(0.3);
    }

        .m-card-block:hover {
            transform: none;
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05), 0 1px 2px rgba(0, 0, 0, 0.1);
        }

    /* Processos Inteligentes: grid 2x2 centralizado com largura controlada */
    .row-cards-links--grid {
        max-width: 760px;
        margin-left: auto;
        margin-right: auto;
    }

    /* lstLinks: três colunas, mesma largura/altura (empilha em telas menores) */
    .row-cards-links .card-opcao.card-opcao-link {
        min-width: 0;
        max-width: none;
        width: 100%;
        height: 100%;
        min-height: 220px;
        max-height: 360px;
    }

    .row-cards-links .card-opcao.card-opcao-link .card-body {
        min-height: 0;
    }

    .title-link-card {
        min-height: 3em;
        line-height: 1.3;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
    }

    /* Cards detalhados (ícones secundários) */
    .icon-wrapper-small {
        width: 64px;
        height: 64px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 16px;
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .card-opcao.animacao:hover .icon-wrapper-small {
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    }

    .img-icone {
        width: 40px;
        max-width: 50px;
        transition: transform 0.3s ease;
    }

    .card-opcao.animacao:hover .img-icone {
        transform: scale(1.1);
    }

    .title {
        font-weight: 600;
        font-size: 1.125rem;
        color: #1e293b;
        letter-spacing: -0.01em;
    }

    /* Footer moderno */
    .footer-text {
        color: #64748b;
        font-weight: 400;
    }

    .footer-link {
        color: inherit;
        text-decoration: none;
        transition: color 0.2s ease;
        font-weight: 500;
    }

        .footer-link:hover {
            color: #3b82f6;
        }

    /* Responsividade refinada */
    @media (max-width: 1399.98px) {
        .card-grid-inicio {
            --card-gap: 0.55rem;
        }

        .card-grid-inicio__wrap .card-opcao {
            min-height: 188px;
            padding: 0.6rem 0.4rem;
        }

        .card-grid-inicio .img-card {
            height: 42px;
        }

        .card-grid-inicio .card-title {
            font-size: 0.86rem;
        }

        .card-grid-inicio .card-description {
            font-size: 0.68rem;
        }
    }

    @media (max-width: 1199.98px) {
        .card-grid-inicio {
            --card-gap: 1rem;
            grid-template-columns: repeat(2, minmax(0, 1fr));
            column-gap: var(--card-gap);
            max-width: 800px;
        }

        .card-grid-inicio__wrap {
            padding: 0;
        }

        .card-grid-inicio__wrap:nth-child(-n + 4),
        .card-grid-inicio__wrap:nth-child(n + 5) {
            grid-column: auto;
        }

        .card-grid-inicio .card-title {
            font-size: 1.15rem;
        }

        .card-grid-inicio .card-description {
            font-size: 0.82rem;
            line-height: 1.5;
            -webkit-line-clamp: 4;
            line-clamp: 4;
        }

        .card-grid-inicio .img-card {
            height: 68px;
        }

        .card-grid-inicio .icon-wrapper {
            margin-bottom: 0.85rem;
        }

        .card-grid-inicio__wrap .card-opcao {
            min-height: 240px;
            padding: 1rem 0.75rem;
        }
    }

    @media (max-width: 768px) {
        .main-title {
            font-size: 1.875rem;
        }

        .subtitle {
            font-size: 1rem;
        }

        .card-opcao {
            min-width: 0;
        }
    }

    @media (max-width: 575.98px) {
        .card-grid-inicio {
            grid-template-columns: 1fr;
            max-width: 400px;
            padding: 0 0.5rem;
        }

        .card-grid-inicio__wrap:nth-child(-n + 4),
        .card-grid-inicio__wrap:nth-child(n + 5) {
            grid-column: auto;
        }

        .card-grid-inicio__wrap .card-opcao {
            min-height: 220px;
        }
    }

    /* Tema Escuro */
    [data-bs-theme="dark"] .main-title {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .subtitle {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .modern-search-input {
        background: #111827;
        border-color: #374151;
        color: #e5e7eb;
    }

    [data-bs-theme="dark"] .logo-avatar {
        filter: drop-shadow(0 4px 14px rgba(59, 130, 246, 0.18));
    }

    [data-bs-theme="dark"] .card-opcao {
        background: linear-gradient(160deg, #243044 0%, #1a2332 100%);
        border-color: rgba(100, 116, 139, 0.28);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.04);
    }

        [data-bs-theme="dark"] .card-opcao::before {
            background: radial-gradient(circle at top left, rgba(59, 130, 246, 0.1), transparent 62%), radial-gradient(circle at bottom right, rgba(139, 92, 246, 0.08), transparent 62%);
        }

        [data-bs-theme="dark"] .card-opcao.animacao:hover {
            border-color: rgba(96, 165, 250, 0.42);
            box-shadow: 0 14px 30px rgba(37, 99, 235, 0.16), 0 6px 14px rgba(0, 0, 0, 0.32), inset 0 1px 0 rgba(255, 255, 255, 0.05);
        }

    [data-bs-theme="dark"] .card-title {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .card-description {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .card-opcao .card-body {
        isolation: isolate;
    }

    [data-bs-theme="dark"] .img-card,
    [data-bs-theme="dark"] .img-icone {
        mix-blend-mode: multiply;
        filter: none;
        filter: invert(80%);
    }

    [data-bs-theme="dark"] .icon-wrapper,
    [data-bs-theme="dark"] .icon-wrapper-small {
        background: transparent !important;
        background-image: none !important;
        border: none !important;
        box-shadow: none !important;
    }

    [data-bs-theme="dark"] .card-opcao.animacao:hover .icon-wrapper,
    [data-bs-theme="dark"] .card-opcao.animacao:hover .icon-wrapper-small {
        background: transparent !important;
        background-image: none !important;
        border: none !important;
        box-shadow: none !important;
    }

    [data-bs-theme="dark"] .m-card-block {
        opacity: 0.38;
        filter: grayscale(0.45);
    }

        [data-bs-theme="dark"] .m-card-block:hover {
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.28), inset 0 1px 0 rgba(255, 255, 255, 0.04);
        }

    [data-bs-theme="dark"] .title,
    [data-bs-theme="dark"] .title-link-card {
        color: #f1f5f9;
    }

    [data-bs-theme="dark"] .footer-text {
        color: #94a3b8;
    }

    [data-bs-theme="dark"] .footer-link:hover {
        color: #60a5fa;
    }

    [data-bs-theme="dark"] :deep(.tyn-footer) {
        border-color: rgba(51, 65, 85, 0.5) !important;
    }

    [data-bs-theme="dark"] :deep(.tyn-footer .bg-white) {
        background: #0f172a !important;
    }

    .invert {
        filter: invert(80%);
        height: 50px !important;
    }

    [data-bs-theme="dark"] .invert {
        filter: none;
        height: 50px !important;
    }

    :deep(.btn-manual-tool) {
        display: inline-flex !important;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 10px 20px;
        border-radius: 10px;
        font-weight: 600;
        font-size: 14px;
        min-height: 42px;
        background: linear-gradient(135deg, #6b7280 0%, #4b5563 100%) !important;
        color: #fff !important;
        border: none !important;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    :deep(.btn-manual-tool:hover) {
        background: linear-gradient(135deg, #4b5563 0%, #374151 100%) !important;
        transform: translateY(-2px);
    }
</style>

